import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { logout } from "../../features/auth";
import { ILoginForm } from "../../models/storeModels/ILoginForm";

const initialState: ILoginForm = {
    databaseOptions: [],
    loginFormIsLoading: false
}

export const loginSlice = createSlice({
    name: 'login',
    initialState,
    reducers: {
        setDatabaseOptions(state, action: PayloadAction<any>) {
            state.databaseOptions = action.payload
        },
        setLoginFormIsLoading(state, action: PayloadAction<any>) {
            state.loginFormIsLoading = action.payload
        },
    },
    extraReducers: (builder) => {
        builder.addCase(logout, () => {
            return initialState
        })
    },
})

export const { setDatabaseOptions, setLoginFormIsLoading } = loginSlice.actions
export const loginReducer = loginSlice.reducer;
